import { render, staticRenderFns } from "./IconAddPlus.vue?vue&type=template&id=1cf20877&"
import script from "./IconAddPlus.vue?vue&type=script&lang=ts&"
export * from "./IconAddPlus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports